// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__345aT","content":"styles_content__39Iu8"};